module.exports = __webpack_public_path__ + "img/html.4d37ab1a.svg";